/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserPreferenceGetSetSettings } from '../../models/user-preference-get-set-settings';

export interface UserPreferenceSettingUpdateUserPreferenceSetting$Params {
  actionType?: string | null;
  practiceId?: string | null;
      body: UserPreferenceGetSetSettings
}

export function userPreferenceSettingUpdateUserPreferenceSetting(http: HttpClient, rootUrl: string, params: UserPreferenceSettingUpdateUserPreferenceSetting$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, userPreferenceSettingUpdateUserPreferenceSetting.PATH, 'put');
  if (params) {
    rb.query('actionType', params.actionType, {});
    rb.query('practiceId', params.practiceId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/octet-stream', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

userPreferenceSettingUpdateUserPreferenceSetting.PATH = '/api/UserPreferenceSetting/updateUserPreferenceSetting';
